var array = Array.prototype;

export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/array.js
// module id = 244
// module chunks = 0